export default "__VITE_ASSET__Bbw8KTCK__"